/* eslint-disable react/forbid-elements */
import * as React from 'react';

export const HouseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19" width="19" height="19">
    <path
      fill="#2E9E00"
      fillRule="evenodd"
      d="M14.677 3.967a36.42 36.42 0 0 1-.744-.484A35.065 35.065 0 0 1 9.5 0a36.555 36.555 0 0 1-4.433 3.483A40.046 40.046 0 0 1 0 6.333V8l2-.084V18a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V8h2V6.333a38.49 38.49 0 0 1-2.78-1.438c-2.956 4.151-5.163 8.22-6.725 11.73-1.293-2.646-3.785-6.049-5.537-7.85l1.677-1.937a26.46 26.46 0 0 1 3.757 4.956c1.3-2.489 3.292-5.324 5.285-7.827z"
    />
  </svg>
);
